export const getValidObject = (object) => {
    if (object) {
        return { ...object };
    }
    return {};
}